import { useMutation, useQueryClient } from '@tanstack/react-query';

import { clientAxios } from '@/shared/api';

const useOnBoardingStatusMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => clientAxios.patch('/patchOnBoardingStatusApi/'),
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: ['getProfileIdApi'],
      });
    },
  });
};

export default useOnBoardingStatusMutation;
